import { CheckboxGroup } from '@chakra-ui/react';

const CheckBoxGroup = CheckboxGroup;

export default CheckBoxGroup;
